/**
 * Pluggable tenant JWT refresh for agent API calls (registered from AuthContext).
 */

let refreshHandler: (() => Promise<boolean>) | null = null;

export function registerTenantAuthRefresh(handler: () => Promise<boolean>): void {
  refreshHandler = handler;
}

export function unregisterTenantAuthRefresh(): void {
  refreshHandler = null;
}

export async function refreshTenantAuth(): Promise<boolean> {
  if (!refreshHandler) return false;
  return refreshHandler();
}
